(() => {
  const initialize = () => {
    window.LotusHomeNavState?.destroy?.();

    const root = document.documentElement;
    const activeMobileItem = document.querySelector('.lh-mobile-nav__item[aria-current="page"]');
    const mobileRail = activeMobileItem?.closest('[data-lh-mobile-nav-rail]');

    if (activeMobileItem && mobileRail) {
      window.requestAnimationFrame(() => {
        mobileRail.scrollLeft = Math.max(0, activeMobileItem.offsetLeft - (mobileRail.clientWidth - activeMobileItem.offsetWidth) / 2);
      });
    }

    const nav = document.querySelector('.lh-home-nav');
    if (!nav) return;

    const setNavState = () => {
      const headerParts = [...document.querySelectorAll('#header-group > *')].filter((part) => {
        const style = getComputedStyle(part);
        const rect = part.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      });
      const announcementHeight = headerParts.reduce((total, part) => {
        if (part.classList.contains('header-section')) return total;
        return total + part.getBoundingClientRect().height;
      }, 0);
      const fixedHeaderHeight = headerParts.reduce((total, part) => total + part.getBoundingClientRect().height, 0);

      if (fixedHeaderHeight > 0) {
        root.style.setProperty('--lh-announcement-height', `${announcementHeight}px`);
        root.style.setProperty('--lh-fixed-header-height', `${fixedHeaderHeight}px`);
      }

      root.classList.toggle('lh-nav-scrolled', window.scrollY > 18);
    };

    setNavState();
    window.addEventListener('scroll', setNavState, { passive: true });
    window.addEventListener('resize', setNavState);
    const headerResizeObserver = 'ResizeObserver' in window ? new ResizeObserver(setNavState) : null;
    document.querySelectorAll('#header-group > *').forEach((part) => headerResizeObserver?.observe(part));

    window.LotusHomeNavState = {
      destroy() {
        window.removeEventListener('scroll', setNavState);
        window.removeEventListener('resize', setNavState);
        headerResizeObserver?.disconnect();
      }
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
